const Vue = require('vue').default || require('vue');
const ImageViewer = require('../components/modal/ImageViewer.vue').default;
const ViewerCtor = Vue.extend(ImageViewer);

module.exports = {
  bind(el, binding) {
    const handler = (e) => {
      let src = '';
      const imgElem = (el.tagName === 'IMG') ? el : (el.querySelector && el.querySelector('img'));
      if (imgElem) src = (binding && binding.value) || imgElem.src || '';
      else src = (binding && binding.value) || '';
      if (!src) return;
      const instance = new ViewerCtor({ propsData: { src } }).$mount();
      document.body.appendChild(instance.$el);
      // provide the thumbnail rect for a smooth open/close animation
      try {
        const rectElem = imgElem || el;
        instance.startRect = rectElem.getBoundingClientRect();
      } catch (e) {}

      // open the viewer immediately
      if (typeof instance.open === 'function') instance.open();

      instance.$on('closed', () => {
        try {
          instance.$destroy();
        } catch (e) {}
        if (instance.$el && instance.$el.parentNode) instance.$el.parentNode.removeChild(instance.$el);
      });
    };
    el.__iv_handler = handler;
    el.addEventListener('click', handler);
  },
  unbind(el) {
    if (el.__iv_handler) {
      el.removeEventListener('click', el.__iv_handler);
      delete el.__iv_handler;
    }
  }
};
